export const PRODUCTS = {
  TYPES: {
    PHYSICAL: {
      ROUTE_NAME: 'physical',
      PRODUCT_NAME: 'Physical Product',
      ID: 1
    },
    INVOICE: {
      ROUTE_NAME: 'invoice',
      PRODUCT_NAME: 'Invoice',
      ID: 2
    },
    EVENT: {
      ROUTE_NAME: 'event',
      PRODUCT_NAME: 'Event',
      ID: 3
    },
    QUICK_PAYMENT: {
      ROUTE_NAME: 'quick-payment',
      PRODUCT_NAME: 'Quick Payment',
      ID: 4
    },
    // QUICK_FAWRY: {
    //     ROUTE_NAME: 'quick-fawry',
    //     PRODUCT_NAME: 'Quick fawry',
    //     ID: 5
    // },
    QUICK_CASH: {
      ROUTE_NAME: 'quick-cash',
      PRODUCT_NAME: 'Quick Cash',
      ID: 6
    },
    Subscription: {
      ROUTE_NAME: 'subscription',
      PRODUCT_NAME: 'Subscription',
      ID: 7
    },
    Calendar: {
      ROUTE_NAME: 'calendar',
      PRODUCT_NAME: 'Calendar',
      ID: 11
    },
    Reservation: {
      ROUTE_NAME: 'reservation',
      PRODUCT_NAME: 'Reservation',
      ID: 13
    },
    COLLECTION: {
      ROUTE_NAME: 'collection',
      PRODUCT_NAME: 'Collection',
      ID: 15
    },
  }
};
